import { API } from "./axiosInstance"

/**
 * Gets all the usergroups with joined tables for one member from usermanagement-service
 * @param {*} staticMemberId The member to get all the contacts for
 * @returns the usergroups with joined objects
 */
export const getFunctionalityMembersforMember = async (staticMemberId) => {
    const functionalityMembers = await API.get(`/functionalitiesMembers?memberId=${staticMemberId}`);
    return functionalityMembers.data;
}

/**
 * Gets all the usergroups with joined tables for one member from usermanagement-service
 * @param {*} id The id to find
 * @returns the usergroups with joined objects
 */
 export const getFunctionalityMemberById = async (id) => {
    const functionalityMembers = await API.get(`/functionalitiesMembers/${id}`);
    return functionalityMembers.data;
}


/**
 * Calls the post functionalitiesMembers endpoint
 * @param {*} functionalityMember the functionalityMember to create
 * @returns the response from usermanagement-service
 */
export const createFunctionalityMember = async (functionalityMember) => {
    const response = await API.post(`/functionalitiesMembers`, functionalityMember);
    return response.data;
}

/**
 * Calls the put functionalitiesMembers endpoint
 * @param {*} functionalityMember the functionalityMember to update
 * @returns the response from usermanagement-service
 */
export const updateFunctionalityMember = async (functionalityMember, staticId) => {
    const response = await API.put(`/functionalitiesMembers/${staticId}`, functionalityMember);
    return response.data;
}

/**
 * Accepts a requested change for a functionalitiesMember
 * @param {*} staticId the id of the functionalitiesMember in the static model
 * @returns the accepted functionalitiesMember
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/functionalitiesMembers/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a functionalitiesMember
 * @param {*} staticId the id of the functionalitiesMember in the static model
 * @returns the rejected functionalitiesMember
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/functionalitiesMembers/${staticId}/reject`);
    return response.data;
}